import { render } from "./Invoiceui.vue?vue&type=template&id=ecd132a4&scoped=true"
import script from "./Invoiceui.vue?vue&type=script&lang=js"
export * from "./Invoiceui.vue?vue&type=script&lang=js"

import "./Invoiceui.vue?vue&type=style&index=0&id=ecd132a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecd132a4"]])

export default __exports__